import script from "./IpOSSolicitacaoViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IpOSSolicitacaoViewPage.vue?vue&type=script&setup=true&lang=js"

import "./IpOSSolicitacaoViewPage.vue?vue&type=style&index=0&id=77826421&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77826421"]])

export default __exports__